import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import { Button, Modal, Paper } from "@material-ui/core";
import { currencyFormat } from "@utils/utils";
import { createBankSlip } from "@redux/actions";
import { useDispatch } from "react-redux";

const EmployeeList = ({ employees, chequeNumber, selectedMonth, onClose, onOpen }) => {
  const dispatch = useDispatch();
  const [selectedEmployees, setSelectedEmployees] = useState([]); 

  const columns = [
    {
      name: "employee_name",
      label: "Employee Name",
      options: {
        filter: false,
      },
    },
    {
      name: "account_No",
      label: "Account No",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta) => {
          // Access the account_No from the employee object
          const employee = employees[tableMeta.rowIndex];
          return employee.employee ? employee.employee.account_No : "";
        },
      },
    },
    {
      name: "final_salary",
      label: "Salary",
      options: {
        filter: false,
        customBodyRender: (value) => currencyFormat(value), // Format Salary in Rs
      },
    },
  ];

  const options = {
    filter: false,
    sort: false,
    responsive: "scroll",
    filterType: "checkbox",
    print: false,
    download: false,
    customToolbarSelect: () => null, // Hide the delete option
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      const selectedIds = allRowsSelected.map(
        (row) => employees[row.dataIndex]._id
      );
      setSelectedEmployees(selectedIds);
    },
  };

  // filter selected employees and set on state in print function
  const handlePrint = () => {
    const selectedEmployeeObjects = employees.filter((employee) =>
      selectedEmployees.includes(employee._id)
    );

    const payload = {
      employees: selectedEmployeeObjects.map((emp) => {
        return {
          name: emp.employee_name,
          salary: emp.final_salary,
          account_no: emp.employee.account_No ? emp.employee.account_No : "",
        };
      }),
      cheque_no: chequeNumber,
      slip_month: selectedMonth,
    };

    dispatch(createBankSlip(payload)).then(() => {
      onClose();
    });
  };

  return (
    <Modal open={onOpen} onClose={onClose} style={modalWrapper}>
      <div style={parentDiv}>
        <Paper
          style={modalPaper}
          component={Paper}
          elevation={3}
          variant="outlined"
          square
        >
          <MUIDataTable
            title="Select Employees"
            data={employees}
            columns={columns}
            options={options}
          />

          <div style={buttonDiv}>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePrint}
              style={button}
              disabled={selectedEmployees.length === 0}
            >
              Generate
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
              style={button}
            >
              Close
            </Button>
          </div>
        </Paper>
      </div>
    </Modal>
  );
};

export default EmployeeList;

// style

const modalWrapper = {
  fontFamily: "Arial",
  maxWidth: "1200px",
};

const parentDiv = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
  width: "90%",
  maxWidth: "900px", // Maximum width for larger screen
  borderRadius: "5px",
};

const modalPaper = {
  padding: "20px",
  margin: "auto",
  overflow: "hidden",
};

const buttonDiv = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const button = {
  marginTop: "8px",
};
